import React from 'react'
import numeral from 'numeral'
import {
  Col, Upload, Input as Ip, DatePicker, Checkbox,
} from 'antd'
import * as UI from 'konsys-ui'
import moment from 'moment'
import _ from 'lodash'
import { detailMode } from '../constants'
import { checkInt, checkCustomerWithCustomRefId, checkNotNumber } from '../../../utils/util-services'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio box
5: Upload box
6: Button
7: Date picker
8: TextArea
9: TextWithLabel
10: TextWithLabelWithId
*/

const { TextArea } = Ip

const convertUnit = (unit) => {
  switch (unit) {
    case 'TON': return 'ตัน'
    case 'KG': return 'กิโลกรัม'
    case 'H50': return 'กระสอบ50'
    case 'TRIP': return 'เที่ยว'
    // case 'H60': return 'กระสอบ60'
    // case 'H100': return 'กระสอบ100'
    default: return 'หน่วย'
  }
}

const CreateMode = ({
  data, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          {
            (data.id !== 'customerRefId' || (data.id === 'customerRefId' && checkCustomerWithCustomRefId(initialData)))
              && <UI.InputWithLabel width='100%' {...data.props} input={{
                onChange: e => onChangeHandler(data.id, data.id === 'customerRefId' ? e.target.value : parseInt(e.target.value, 10)),
                onKeyDown: (e) => {
                  if (data.dataType === 'int' && !checkInt(e)) {
                    e.preventDefault()
                  }
                },
                ...data.props.input,
                type: data.dataType === 'int' ? 'number' : 'text',
                step: data.dataType === 'int' ? '1' : undefined,
                min: '0',
              }} />
          }
        </Col>
      )
    case 1:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div >
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
              {/* <UI.P bold margin='0 64px 0 0'>{_.isNull(initialData.companyId) ? '-' : initialData.companyId}</UI.P>
              <UI.P bold>{_.isNull(initialData[data.id]) ? '-' : initialData[data.id]}</UI.P> */}
              <UI.P bold>{initialData[data.id]} - {initialData.branch}</UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 2:
      return (
        <Col span={data.span} offset={data.offset} style={{ paddingTop: '6px' }}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 18px'>{data.props.title.text}</UI.P>
            <DatePicker
              onChange={(e) => {
                onChangeHandler(data.id, e)
              }}
              defaultValue={moment(mutationVariables[data.id])}
              value={mutationVariables[data.id] !== 'Invalid date' && moment(mutationVariables[data.id])}
              {...data.props}
            />
          </UI.Div>
        </Col>
      )
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 8:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <TextArea
            {...data.props}
            onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </UI.Div>
      </Col>
    case 9:
      return <Col span={data.span} offset={data.offset}></Col>
    case 10:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
            <UI.P bold margin='6px 8px 8px 0'>
              {
                _.isNull(initialData[data.id])
                  ? '-' : data.id === 'shippingCount' || data.id === 'cargo'
                    ? initialData[data.id]
                    : initialData.groupId === 6 && data.id === 'shippingGrandTotal'
                      ? parseFloat(initialData[data.id]).toFixed(3)
                      : parseFloat(initialData[data.id]).toFixed(2)
              }&nbsp;
              {
                data.id === 'totalWeight'
                  ? convertUnit(initialData.shippingUnit)
                  : (data.id === 'contractWeight' || data.id === 'deliveredWeight')
                    ? initialData.dealType === 'PERTRIP'
                      ? 'เที่ยว'
                      : initialData.dealType === 'PERWEIGHT'
                        ? 'ตัน'
                        : data.unit
                    : data.id === 'shippingCount'
                      ? 'เที่ยว'
                      : data.id === 'shippingGrandTotal' && 'บาท'
              }
              {/* {
                data.id === 'totalWeight'
                  ? convertUnit(initialData.shippingUnit)
                  : initialData.dealType === 'PERTRIP'
                    ? 'เที่ยว'
                    : initialData.dealType === 'PERWEIGHT'
                      ? 'ตัน'
                      : data.unit
                } */}
              </UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
              <UI.P bold margin='0 8px 0 0'>{initialData[data.id]} {data.unit}</UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
              <UI.P bold margin='0 8px 0 0'>
              {
                numeral(initialData[data.id]).format('0,0.00')
              } {
                initialData.dealType === 'PERTRIP' ? 'เที่ยว' : 'ตัน'
              }
              </UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 13.1:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' alignItems='flex-end' >
            <UI.InputWithLabel {...data.props}
              input={{
                type: 'number',
                step: '0.01',
                min: '0',
                value: mutationVariables.pricePerLitre,
                onKeyDown: e => checkNotNumber(e) && e.preventDefault(),
                onChange: e => onChangeHandler(data.id, parseFloat(e.target.value)),
              }}
          />
          <UI.P margin='0 0 14px 16px'>{data.unit}</UI.P>
          </UI.Div>
        </Col>
      )
    case 13.2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' alignItems='flex-end' >
            <UI.InputWithLabel {...data.props}
              input={{
                type: 'number',
                step: '0.01',
                min: '0',
                value: mutationVariables.feeRate,
                onKeyDown: e => checkNotNumber(e) && e.preventDefault(),
                onChange: e => onChangeHandler(data.id, parseFloat(e.target.value)),
              }}
          />
          <UI.P margin='0 0 14px 16px'>{data.unit}</UI.P>
          </UI.Div>
        </Col>
      )
    case 14:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' alignItems='center' margin='22px 0 0 0'>
          <Checkbox
            margin='25px 0'
            onChange={(e) => {
              onChangeHandler(data.id, e.target.checked)
            }}
          >ปรับค่าขนส่งในใบสั่งบรรทุก</Checkbox>
          </UI.Div>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler, mutationVariables,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          {
            (data.id !== 'customerRefId' || (data.id === 'customerRefId' && checkCustomerWithCustomRefId(initialData.Job.Customer)))
              && <UI.InputWithLabel width='100%' margin='0 !important' {...data.props} input={{
                disabled,
                defaultValue: initialData[data.id],
                onChange: e => onChangeHandler(data.id, data.id === 'customerRefId' ? e.target.value : parseInt(e.target.value, 10)),
                onKeyDown: (e) => {
                  if (data.dataType === 'int' && !checkInt(e)) {
                    e.preventDefault()
                  }
                },
                ...data.props.input,
                type: data.dataType === 'int' ? 'number' : 'text',
                step: data.dataType === 'int' ? '1' : undefined,
                min: '0',
              }} />
          }
        </Col>
      )
    case 1:
      return (
          <Col span={data.span} offset={data.offset}>
            <UI.Div >
              <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
              <UI.Div>
                <UI.P bold margin='0 64px 0 0'>{_.isNull(initialData[data.id]) ? '-' : initialData[data.id]} - {_.isNull(initialData.branch) ? '-' : initialData.branch}</UI.P>
              </UI.Div>
            </UI.Div>
          </Col>
      )
    case 2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <DatePicker
              onChange={e => onChangeHandler(data.id, e)}
              disabled={disabled}
              defaultValue={moment(initialData[data.id])}
              {...data.props}
            />
          </UI.Div>
        </Col>
      )
    case 3:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div >
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <DatePicker
              onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
              disabled={disabled}
              defaultValue={moment(initialData[data.id])}
              {...data.props}
            />
          </UI.Div>
        </Col>
      )
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={!_.isNull(initialData[data.id]) && initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 8:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <TextArea disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </UI.Div>
      </Col>
    case 9:
      return <Col span={data.span} offset={data.offset}>
        <UI.Div display='flex' flexDirection='column' alignItems='flex-start' alignSelf='flex-start'>
          <UI.P {...data.props}>{data.props.title.text}</UI.P>
          <UI.P bold margin='16px 0 0'>{_.isNull(initialData[data.id])
            ? '-'
            : data.dataType === 'date'
              ? moment(initialData[data.id]).format('DD MMMM YYYY')
              : data.id === 'dealType'
                ? (initialData[data.id] === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว')
                : initialData[data.id]}</UI.P>
        </UI.Div>
      </Col>
    case 10:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
            <UI.P bold margin='6px 8px 8px 0'>
                {
                  _.isNull(initialData[data.id])
                    ? '-' : data.id === 'shippingCount' || data.id === 'cargo'
                      ? initialData[data.id]
                      : initialData.groupId === 6 && data.id === 'shippingGrandTotal'
                        ? parseFloat(initialData[data.id]).toFixed(3)
                        : parseFloat(initialData[data.id]).toFixed(2)
                }&nbsp;
                {
                  data.id === 'totalWeight'
                    ? !_.isEmpty(initialData.shippings) ? convertUnit(initialData.shippings[0].unit) : '-'
                    : (data.id === 'contractWeight' || data.id === 'deliveredWeight')
                      ? initialData.Job.dealType === 'PERTRIP'
                        ? 'เที่ยว'
                        : initialData.Job.dealType === 'PERWEIGHT'
                          ? 'ตัน'
                          : data.unit
                      : data.id === 'shippingCount'
                        ? 'เที่ยว'
                        : data.id === 'shippingGrandTotal' && 'บาท'
                }
              </UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
              <UI.P bold margin='0 8px 0 0'>{initialData[data.id]} {data.unit}</UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.props.title.text}</UI.P>
            <UI.Div>
              <UI.P bold margin='0 8px 0 0'>
              {numeral(initialData[data.id]).format('0,0.00')} {initialData.Job.dealType === 'PERTRIP' ? 'เที่ยว' : 'ตัน'}
              </UI.P>
            </UI.Div>
          </UI.Div>
        </Col>
      )
    case 13.1:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' alignItems='flex-end' >
            <UI.InputWithLabel {...data.props}
              input={{
                disabled,
                type: 'number',
                step: '0.01',
                min: '0',
                initialData: initialData.pricePerLitre,
                value: !_.isUndefined(mutationVariables.pricePerLitre) ? mutationVariables.pricePerLitre : initialData.pricePerLitre,
                onKeyDown: e => checkNotNumber(e) && e.preventDefault(),
                onChange: e => onChangeHandler(data.id, parseFloat(e.target.value)),
              }}
          />
          <UI.P margin='0 0 14px 16px'>{data.unit}</UI.P>
          </UI.Div>
        </Col>
      )
    case 13.2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' alignItems='flex-end' >
            <UI.InputWithLabel {...data.props}
              input={{
                disabled,
                type: 'number',
                step: '0.01',
                min: '0',
                initialData: initialData.feeRate,
                value: !_.isUndefined(mutationVariables.feeRate) ? mutationVariables.feeRate : initialData.feeRate,
                onKeyDown: e => checkNotNumber(e) && e.preventDefault(),
                onChange: e => onChangeHandler(data.id, parseFloat(e.target.value)),
              }}
          />
          <UI.P margin='0 0 14px 16px'>{data.unit}</UI.P>
          </UI.Div>
        </Col>
      )
    case 14:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.Div display='flex' alignItems='center' margin='22px 0 0 0'>
          <Checkbox
            onChange={(e) => {
              onChangeHandler(data.id, e.target.checked)
            }}
          >ปรับค่าขนส่งในใบสั่งบรรทุก</Checkbox>
          </UI.Div>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} mutationVariables={mutationVariables} onChangeHandler={(id, value) => onChangeHandler(id, value)} initialData={initialData}/>
    case detailMode.EDIT:
      return <EditMode data={data} mutationVariables={mutationVariables} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} mutationVariables={mutationVariables} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
